<template>
    <!-- ОТРИСОВКА БЛОКОВ -->
    <div class="not_found">
        <div class="wrapper_center">
            <h1 class="four_zero_four">404</h1>
        </div>
        
        <h1 class="not_found_text">Страница не найдена</h1>
        <div class="img_gif">
            <img ref="img_gif" :src="showImage(gif_url)" alt="">
        </div>
        
    </div>
</template>

<script>

export default{
    data(){
        return {
            gif_url: 'friends-joey.gif',
            gifs: [
                    'woody-woodpecker-shrug-shoulders.gif',
                    'shrug.gif',
                    'okay-onepunchman.gif',
                    'mob-psycho-rage.gif',
                    'elmo-shrug.gif', 
                    'friends-joey.gif',
                    'the-office-karen-filippelli.gif', 
                    'vampire-diaries-the-vapire-diaries.gif',
                    'uzaki-chan-uzaki.gif',
                    'vampire-diaries-the-vapire-diaries.gif'
                ]
        }
    },
    mounted(){
        this.gif_url = this.gifs[this.getRandomNumber(0, this.gifs.length-1)];
        console.log(this.gif_url);
    },
    methods: {
        getRandomNumber(min, max) {
            return Math.round(Math.random() * (max - min) + min)
        },
        showImage(url) {
            if (url !== ''){ // You can check any matching expression.
                try {
                    url = require('@/assets/gifs/' + url)
                } catch (e) {
                    url = require('@/assets/gifs/elmo-shrug.gif'); // I used a default image. 
                }
            }
            else
                url = require('@/assets/gifs/elmo-shrug.gif'); // Default image. 
            return url;
        }
    },
   

}

</script>

<style lang="scss" scoped>
.wrapper_center{
    display: flex;
    justify-content: center;

    .four_zero_four{
        display: inline-block;
        background-color: transparent;
        width: 100px;
        height: 100px;
        line-height: 100px;
        border-radius: 50%;
        border:2px dashed grey;
        font-family: 'Asher Punk', sans-serif;
    }
}


.not_found_text{
    padding: 0 20px;
}
.not_found img{
    max-width: 300px;
    width: 100%;
    display: block;
    margin: 0 auto;
    // padding: 20px;
    border-radius: 8px;
}

.img_gif{
    padding: 20px;
    // border-radius: 8px;
}


</style>
